class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const targetSectionElement = doc.querySelector(selector);
  
    if (targetSectionElement) {
      // Select all elements that represent a single cart item line.
      // Ensure these selectors correctly target the main <li> or <tr> for each item.
      const lineItemWrappers = targetSectionElement.querySelectorAll('ul.mini-cart__navigation > li, .cart-item, tr[data-line-item-key], li[data-line-item-key]');
  
      lineItemWrappers.forEach(lineItemElement => {
        const propertiesAttrRaw = lineItemElement.getAttribute('data-cart-item-properties');
        let properties = {}; // Initialize as empty object
  
        if (propertiesAttrRaw) {
          let propertiesAttr = propertiesAttrRaw;
  
          // NEW: Unescape HTML entities if they are present in the attribute value
          // This is crucial because `&quot;` (for ") and `&amp;` (for &) are breaking JSON.parse()
          try {
            // Create a temporary element to unescape the HTML entities
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = propertiesAttrRaw;
            propertiesAttr = tempDiv.textContent || tempDiv.innerText || propertiesAttrRaw; // Get unescaped text
          } catch (e) {
            console.error("Error unescaping HTML entities in properties attribute:", e, propertiesAttrRaw);
            // Fallback to raw string if unescaping fails, will be handled by next try/catch
            propertiesAttr = propertiesAttrRaw;
          }
  
          try {
            // Attempt to parse as standard JSON (now with unescaped quotes)
            properties = JSON.parse(propertiesAttr);
          } catch (e) {
            // If standard JSON parsing still fails (e.g., it's the array-of-arrays format, or other issues)
            // then proceed with custom parsing logic.
            console.warn("Attempting custom parsing for data-cart-item-properties. Error:", e, "Raw data (unescaped):", propertiesAttr);
  
            // Custom parsing for the `[["key","value"],...]` format
            const cleanedAttr = propertiesAttr.replace(/^\[\[\s*/, '').replace(/\s*\]\]$/, '');
            const pairs = cleanedAttr.split(/\s*\],\[\s*/);
  
            pairs.forEach(pair => {
              const parts = pair.split(',');
              if (parts.length >= 2) {
                let key = parts[0].trim().replace(/^"|"$/g, '');
                let value = parts.slice(1).join(',').trim();
  
                if (value === 'true') value = true;
                else if (value === 'false') value = false;
                else if (!isNaN(Number(value)) && !isNaN(parseFloat(value))) value = Number(value);
                else value = value.replace(/^"|"$/g, '').replace(/\\\"/g, '"');
  
                // Specific handling for GIDs that might have extra escaped slashes if they were malformed
                if (key.includes('gid') && typeof value === 'string') {
                    value = value.replace(/\\/g, '');
                }
  
                properties[key] = value;
              }
            });
  
          }
        }
  
        // 1. Hide the entire line item if it's marked as a hidden bundle component
        if (properties['_hidden_item'] === true) {
          lineItemElement.remove(); // Remove the entire <li> or <tr> element
          return; // Skip further processing for this item as it's removed
        }
  
        // 2. Hide specific properties that start with an underscore for visible items
        const propertyDisplayElements = lineItemElement.querySelectorAll('.product-option dt, .product-option dd, .cart-item__properties li, .cart-item__details-meta > li, dd');
  
        propertyDisplayElements.forEach(propEl => {
          const textContent = propEl.textContent.trim();
          const propertyNameMatch = textContent.match(/^([^:]+):/);
  
          let propertyKeyToCheck = null;
          if (propertyNameMatch && propertyNameMatch[1]) {
            propertyKeyToCheck = propertyNameMatch[1].trim();
          } else {
            propertyKeyToCheck = textContent;
          }
  
          if (
              propertyKeyToCheck === '_Bundle Type' ||
              propertyKeyToCheck === '_Bundle Components Data' ||
              propertyKeyToCheck === '_Bundle Group ID' ||
              propertyKeyToCheck.startsWith('_')
          ) {
            propEl.remove();
          }
        });
  
        // Additional cleanup: Remove empty .product-option divs or <dl> if all their content (dt/dd) has been removed.
        lineItemElement.querySelectorAll('.product-option, dl').forEach(emptyContainer => {
          if (emptyContainer.innerHTML.trim() === '' || emptyContainer.children.length === 0) {
            emptyContainer.remove();
          }
        });
      });
      return targetSectionElement.innerHTML;
    }
    return '';
  }
  // >>>>>>>>>>>>>> END OF MODIFIED getSectionInnerHTML FOR MiniCart <<<<<<<<<<<<<<
}

customElements.define('mini-cart', MiniCart);